export const enum BuildTarget {
    Web = "web",
    Mobile = "mobile",
    Desktop = "dl",
}

// 定数クラス
export class Const
{
    // ビルドバージョン *Web版リリースのたびにインクリメントすること
    public static BUILD_VERSION = "10010";

    public static get BUILD_OPTION(): BuildTarget {
        switch (process.env.VUE_APP_BUILD_TARGET) {
            case "mobile": return BuildTarget.Mobile;
            // case "dl": return BuildTarget.Desktop;
            default: return BuildTarget.Web;
        }
        // DesktopはUserAgentで判定するので不要
    }

    public static CANVAS_SIZE_FACTOR : number = 100;
    public static CANVAS_ZOOM_MAX = 1000;
    public static CANVAS_ZOOM_MIN = 25;
    public static BLEED_SIZE_MAX : number = 10.0;

    public static API_URL_BASE : string = process.env.VUE_APP_API_URL_BASE;
    public static IFRAME_URL_BASE : string = process.env.VUE_APP_IFRAME_URL_BASE;
    // https://emix.entap.co.jp/yoshii_ssl_test/
    // https://labelten-test.labelyasan.com/web/
    // https://labelten.labelyasan.com/web/

    public static API_URL_BASE_CDN : string = "https://labelten.labelyasan.com/api/1/";
    public static PRODUCT_DETAIL_URL_BASE = "http://www.a-one.co.jp/product/search/detail.php?id=";

    // S3 Assets
    public static IMAGE_URL_BASE = "https://7ebb9ef9d2fb26fe5b59eccd44dd0420.cdnext.stream.ne.jp/uiImage/";

    // google以外のwebfont
    public static WEBFONT_URL_BASE = "https://7ebb9ef9d2fb26fe5b59eccd44dd0420.cdnext.stream.ne.jp/webfonts/";

    // OCRBフォント
    public static FONT_FAMILY_OCRB = "ocrBarcode";
    // OCRBフォントの幅のフォントサイズに対する割合
    public static FONT_WIDTH_RATION_OCRB = 0.72265625;
    // JANバーコード最小サイズ
    public static BARCODE_JAN_MIN_WIDTH = 29.83;
    public static BARCODE_JAN_MIN_HEIGHT = 9.0;

    //↓最終的にはサーバー上の絶対的なパスになる
    public static GET_TEMPLATE_URL_BASE : string = "./resources/template/"
    public static ENCRYPTION_PASSWORD : string = "password"

    // ファイルバージョン
    public static FILE_VERSION = 6;
    // ファイル作成環境
    public static FILE_ENVIRONMENT = "1.5.4";
    // ファイル拡張子
    // プロジェクトファイル
    // デバッグ期間中は"d"を付与する
    public static PROJECT_FILE_EXTENSION = ".aly"; //".aly";
    public static INSERTION_FILE_EXTENSION = ".alym"; // ".alym";
    public static TEMPLATE_FILE_EXTENSION = ".alyt";
    // 差し込みCSVファイル名
    public static CSV_FILE_NAME = "labelyasan10_export_{DATE}.csv"

    // アンドゥの最大数
    public static UNDO_STACK_SIZE = 12;

    // 最大ページ数
    public static MAX_PAGE_NUMBER = 500;

    // プロフィールキー
    public static PROFILE_KEY_PREFIX = "prof";
    public static PROFILE_KEY_SEPARATOR = ":";
    public static PROFILE_KEY_NAME = "name";
    public static PROFILE_KEY_FURIGANA = "furigana";
    public static PROFILE_KEY_NAME_ROMAN = "name_roman";
    public static PROFILE_KEY_CELL_TEL = "cell_tel";
    public static PROFILE_KEY_MAIL = "mail";
    public static PROFILE_KEY_COMPANY = "company";
    public static PROFILE_KEY_DIV = "div";
    public static PROFILE_KEY_TEL = "tel";
    public static PROFILE_KEY_FAX = "fax";
    public static PROFILE_KEY_ZIP = "zip";
    public static PROFILE_KEY_ADDRESS1 = "address";
    public static PROFILE_KEY_ADDRESS2 = "address2";
    public static PROFILE_KEY_URL = "url";

    // フォント設定
    public static UI_FONT_ID = "noto-sans-jp-700";
    public static UI_FONT_WEIGHT = "700";

    // 印刷レコメンド最低表示時間
    public static PRINT_LOADING_MIN_MILLISECONDS = 6 * 1000;

    // ラベル屋さんのバージョン（仮置き）
    public static LABELYASAN_TEN_VERSION = "0.0.1";

    // ラベル屋さんクラウドの放置時の自動ログアウト時間（分）
    public static LABELYASAN_CLOUD_SIGN_OUT_TIME = 15;
    // ラベル屋さんクラウドのリフレッシュトークンの更新時間
    public static LABELYASAN_CLOUD_UPDATE_REFRESH_TOKEN_TIME = 30;

    // テンプレートID：twitter
    public static TEMPLATE_ID_TWITTER = 10001;
    // テンプレートID：Facebook
    public static TEMPLATE_ID_FACEBOOK = 10002;

    // iframeと共有するSNSのcontentsキー
    public static SNS_CONTENTS_ACCOUNT_NAME = "sns_account_name";
    public static SNS_CONTENTS_ACCOUNT_ICON = "sns_account_icon";
    public static SNS_CONTENTS_ACCOUNT_TEXT = "sns_account_text";
    public static SNS_CONTENTS_ACCOUNT_IMAGE = "sns_account_image";
    public static SNS_CONTENTS_ACCOUNT_FAVORITE_COUNT = "sns_account_favorite_count";
    public static SNS_CONTENTS_ACCOUNT_DATE_TEXT = "sns_account_date_text";

    // イメージが貼り付け面に対してこのDPIより大きいとき警告する
    public static IMAGE_TOO_LARGE_DPI = 350.0;

    // フォント名から適切なウェブフォントのIDを得る
    // font: 日本語フォント名(Label9でのフォント名、表示フォント名)
    // name: PostScript名(フォントID)
    // id: 変換先のフォントID
    public static FONT_CONVERT_MAP : Array<{font : string, name : string, id : string}> =
    [
        { font : "ＭＳ Ｐゴシック", name : "MS-PGothic", id : "noto-sans-jp-400" },
        { font : "ＭＳ ゴシック", name : "MS-Gothic", id : "noto-sans-jp-400" },
        { font : "メイリオ", name : "Meiryo", id : "noto-sans-jp-400" },
        { font : "Arial", name : "ArialMT", id : "open-sans-400" },
        { font : "Times New Roman", name : "TimesNewRomanPSMT", id : "lusitana-400" },
        { font : "ＭＳ 明朝", name : "MS-Mincho", id : "noto-serif-jp-400" },
        { font : "Arial Black", name : "Arial-Black", id : "open-sans-800" },
        { font : "ＭＳ Ｐ明朝", name : "MS-PMincho", id : "noto-serif-jp-400" },
        { font : "Impact", name : "Impact", id : "anton" },
        { font : "Comic Sans MS", name : "ComicSansMS", id : "mclaren" },
        { font : "小塚ゴシック Pro B", name : "KozGoPro-Bold", id : "noto-sans-jp-500" },
        { font : "Trebuchet MS", name : "TrebuchetMS", id : "fira-sans-400" },
        { font : "小塚明朝 Pro H", name : "KozMinPro-Heavy", id : "noto-serif-jp-700" },
        { font : "Courier New", name : "CourierNewPSMT", id : "cutive" }, 
        { font : "Century", name : "Century", id : "cutive-mono" }, 
        { font : "Verdana", name : "Verdana", id : "lato-400" }, 
        { font : "Georgia", name : "Georgia", id : "vollkorn-400" }, 
        { font : "Century Gothic", name : "CenturyGothic", id : "muli-400" }, 
        { font : "Arial Narrow", name : "ArialNarrow", id : "open-sans-condensed-300" }, 
        { font : "Bell MT", name : "BellMT", id : "cardo-400" }, 
        { font : "Arial Rounded MT Bold", name : "ArialRoundedMTBold", id : "work-sans-400" },
        { font : "KaiTi", name : "KaiTi", id : "noto-sans-sc-400" },
        { font : "Gungsuh", name : "Gungsuh", id : "noto-serif-kr-400" }
    ];
}
